import { getAccountInfo } from '@/services/profile';

import { unwrapData } from './utils';

/**
 * Keys of the profile area (the partner's account / business info). The signed-in user's own
 * profile stays in `AuthProvider` (out of scope), so there is no user query here.
 * Every profile query starts with `profileKeys.all`.
 * Invalidated by: `useUpdateUserInfo` (all of `profileKeys.all`), `useUpdateAccountInfo`
 * (`profileKeys.accountInfo()`), see `src/mutations/profile.ts`.
 */
export const profileKeys = {
  all: ['profile'] as const,
  accountInfo: () => [...profileKeys.all, 'account'] as const,
};

/**
 * Query for the partner's account (business) info: legal name, business type, years of operation,
 * address, terms version.
 * What: resolves to the account (`response.data.data`).
 * Why: Settings > Account Details shows it and the sign-up wizard builds its start state from it.
 * Key: `['profile', 'account']`.
 * Invalidated by: W13 `updateAccountInfo` and W12 `updateUserInfo`.
 */
export const accountInfoQuery = () => ({
  queryKey: profileKeys.accountInfo(),
  queryFn: ({ signal }: { signal?: AbortSignal }) =>
    getAccountInfo(signal).then((response) => unwrapData(response.data.data)),
});
